import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
import "../../../../../index.css";
class SubjectRankCategory extends Component {
  render() {
    const { categories } = this.props;
    return (
      <div className="subjectRankCategory_box">
        {categories.map((item, index) => {
          if (index >= 3) {
            return (
              <NavLink
                to={"/rank/subject/subclass/" + item.hashId}
                style={{ marginTop: 25 }}
                key={index}
                className="subjectRankCategory_subject_box fl"
              >
                <img alt="" src={item.icon_url}></img>
                <div>{item.name}</div>
              </NavLink>
            );
          } else {
            return (
              <NavLink
                to={"/rank/subject/subclass/" + item.hashId}
                key={index}
                className="subjectRankCategory_subject_box fl"
              >
                <img alt="" src={item.icon_url}></img>
                <div>{item.name}</div>
              </NavLink>
            );
          }
        })}

        <div className="clear"></div>
      </div>
    );
  }
}

export default SubjectRankCategory;



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankCategory/index.js